import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import BatteryChargingIcon from '@mui/icons-material/BatteryChargingFullOutlined';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import { Box, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import { RowData } from './CollapsibleList';
import { ServiceCard, ServiceCardContent } from '../ServiceCard/ServiceCard';
import { FC } from 'react';
import { IconType } from '../../enums/IconType';
import { SxProps } from '@mui/system';
import { withStyles } from '@mui/styles'

const classes: SxProps = {
  iconSmall: {
    fontSize: 8
  },
  iconLarge: {
    fontSize: 14,
    minWidth: 40,
    marginLeft: 0.5
  },
  iconCentered: {
    fontSize: 24,
    marginLeft: -0.5
  },
  iconCharging: {
    fontSize: 28,
    marginLeft: -0.5
  },
  listTextCharging: {
    flex: "100%"
  },
};

type Props = {
  row: RowData;
  small: boolean;
};

const StyledListItemTime = withStyles((props) => {
  return ({
    root: {
      'margin-right': '10px',
      flex: '0 0 auto'
    }
  })
})(ListItemText)



export const Row: FC<Props> = ({ row }) => {
  if (row.loadTime!) {
    return (
      <>
        <ListItem dense>
          <ListItemIcon sx={classes.iconLarge}>
            <FiberManualRecord fontSize={'inherit'} sx={classes.fiber} />
          </ListItemIcon>
          <ListItemText
            primary={`${row.arrivalTime} ank`}
            sx={classes.timeBox}
          />
          <ListItemText primary={row.text} />
        </ListItem>
        <ListItem dense>
          <ListItemIcon sx={classes.iconLarge}>
            <FiberManualRecord fontSize={'inherit'} sx={classes.fiber} />
          </ListItemIcon>
          <ListItemText
            primary={`${row.departureTime} avg`}
            sx={classes.timeBox}
          />
          <ListItemText primary={row.text} />
        </ListItem>
      </>
    );
  } else if (row.serviceMessage === '') {
    return (
      <>
        <ListItem dense>
          <ListItemIcon sx={classes.iconLarge}>
            {row.icon === IconType.House && <HomeWorkIcon />}
            {row.icon === IconType.Stop && (
              <FiberManualRecord fontSize={'inherit'} sx={classes.fiber} />
            )}
          </ListItemIcon>
          <StyledListItemTime primary={row.departureTime} sx={classes.timeBox} />

          <ListItemText primary={row.text} />
        </ListItem>
        {row.trpptTpNote! && row.ttpNoteText! && (
          <ListItem dense sx={classes.ttpTextItem}>
            <Box px={1}>
              <ListItemText primary={row.trpptTpNote} />
            </Box>
            <ListItemText primary={row.ttpNoteText} />
          </ListItem>
        )}
        {row.trpptFac && (
          <ListItem dense>
            <ListItemIcon sx={classes.iconLarge}>
              {row.trpptFac.includes('Ladda') && (
                <BatteryChargingIcon sx={classes.iconCharging} color="success" />
              )}
              {row.trpptFac.includes('Paus') && (
                <FreeBreakfastIcon sx={classes.iconCentered} />
              )}
              {!row.trpptFac.includes('Ladda') &&
                !row.trpptFac.includes('Paus') && (
                  <PriorityHighIcon sx={classes.iconCentered} />
                )}
            </ListItemIcon>
            {(row.trpptFac.includes('Ladda') || row.trpptFac.includes('Paus')) && (
              <ListItemText
                primary={
                  row.trpptFac.includes('Ladda') || row.trpptFac.includes('Paus')
                    ? ''
                    : row.departureTime
                }
              />
            )}
            <ListItemText primary={row.trpptFac} sx={classes.listTextCharging} />
          </ListItem>
        )}
      </>
    );
  } else if (row.serviceMessage !== '') {
    return (
      <ServiceCard>
        <ServiceCardContent serviceMessage={row.serviceMessage} />
      </ServiceCard>
    );
  } else {
    return <>Oops!</>;
  }
};
